// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/experiment_metadata.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "../../../../google/protobuf/timestamp_pb";
import { file_google_protobuf_timestamp } from "../../../../google/protobuf/timestamp_pb";
import type { ResourceStatus } from "./resource_status_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_resource_status } from "./resource_status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/experiment_metadata.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_experiment_metadata: GenFile = /*@__PURE__*/
  fileDesc("CkFxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZXhwZXJpbWVudF9tZXRhZGF0YS5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxIuQFChJFeHBlcmltZW50TWV0YWRhdGESGgoNZXhwZXJpbWVudF9pZBgBIAEoCUgAiAEBEhwKD2V4cGVyaW1lbnRfbmFtZRgCIAEoCUgBiAEBEjoKEWNyZWF0ZWRfdGltZXN0YW1wGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgCiAEBEjsKEm1vZGlmaWVkX3RpbWVzdGFtcBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIA4gBARIXCgpjcmVhdGVkX2J5GAUgASgJSASIAQESHQoQbGFzdF9tb2RpZmllZF9ieRgGIAEoCUgFiAEBEiAKE2hhc19pbnN0cnVtZW50X2RhdGEYByABKAhIBogBARIhChRoYXNfYW5hbHlzaXNfcmVzdWx0cxgIIAEoCEgHiAEBEkwKBnN0YXR1cxgJIAEoDjI3LnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5SZXNvdXJjZVN0YXR1c0gIiAEBEhEKCWFzc2F5X2lkcxgKIAMoCRISCgpzYW1wbGVfaWRzGAsgAygJEh8KEmluc3RydW1lbnRfZGF0YV9pZBgMIAEoCUgJiAEBEiMKFmluc3RydW1lbnRfZGF0YV9mb3JtYXQYDSABKAlICogBAUIQCg5fZXhwZXJpbWVudF9pZEISChBfZXhwZXJpbWVudF9uYW1lQhQKEl9jcmVhdGVkX3RpbWVzdGFtcEIVChNfbW9kaWZpZWRfdGltZXN0YW1wQg0KC19jcmVhdGVkX2J5QhMKEV9sYXN0X21vZGlmaWVkX2J5QhYKFF9oYXNfaW5zdHJ1bWVudF9kYXRhQhcKFV9oYXNfYW5hbHlzaXNfcmVzdWx0c0IJCgdfc3RhdHVzQhUKE19pbnN0cnVtZW50X2RhdGFfaWRCGQoXX2luc3RydW1lbnRfZGF0YV9mb3JtYXRiBnByb3RvMw", [file_google_protobuf_timestamp, file_quanterix_simoa_one_analysis_app_api_v1_resource_status]);

/**
 * Contains metadata describing an experiment
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ExperimentMetadata
 */
export type ExperimentMetadata = Message<"quanterix.simoa_one.analysis_app_api.v1.ExperimentMetadata"> & {
  /**
   * Unique identifier (UUID)
   *
   * @generated from field: optional string experiment_id = 1;
   */
  experimentId?: string;

  /**
   * User-friendly experiment name
   *
   * @generated from field: optional string experiment_name = 2;
   */
  experimentName?: string;

  /**
   * Represents the point in time at which the experiment was created,
   * independent of timezone
   *
   * @generated from field: optional google.protobuf.Timestamp created_timestamp = 3;
   */
  createdTimestamp?: Timestamp;

  /**
   * Represents the point in time at which the experiment was last modified,
   * independent of timezone
   *
   * @generated from field: optional google.protobuf.Timestamp modified_timestamp = 4;
   */
  modifiedTimestamp?: Timestamp;

  /**
   * Represents the identity of the user who created the experiment
   *
   * @generated from field: optional string created_by = 5;
   */
  createdBy?: string;

  /**
   * Represents the identity of the user who last modified the experiment
   *
   * @generated from field: optional string last_modified_by = 6;
   */
  lastModifiedBy?: string;

  /**
   * True if the experiment contains associated instrument data
   *
   * @generated from field: optional bool has_instrument_data = 7;
   */
  hasInstrumentData?: boolean;

  /**
   * True if the experiment has associated analysis results
   *
   * @generated from field: optional bool has_analysis_results = 8;
   */
  hasAnalysisResults?: boolean;

  /**
   * State of the experiment resource (e.g. in draft, locked, etc.)
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ResourceStatus status = 9;
   */
  status?: ResourceStatus;

  /**
   * Set of unique ids for assays used within this experiment
   *
   * @generated from field: repeated string assay_ids = 10;
   */
  assayIds: string[];

  /**
   * Set of unique ids for samples under test in this experiment
   *
   * @generated from field: repeated string sample_ids = 11;
   */
  sampleIds: string[];

  /**
   * Unique ID for the instrument data results associated with this experiment
   *
   * @generated from field: optional string instrument_data_id = 12;
   */
  instrumentDataId?: string;

  /**
   * The format of the instrument data. Only set if has_instrument_data is true.
   * Current options are 'rpck' and 'cytek'
   *
   * @generated from field: optional string instrument_data_format = 13;
   */
  instrumentDataFormat?: string;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ExperimentMetadata.
 * Use `create(ExperimentMetadataSchema)` to create a new message.
 */
export const ExperimentMetadataSchema: GenMessage<ExperimentMetadata> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_experiment_metadata, 0);

